// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1xXzq","fileBtn":"File_fileBtn__2eCTA","closeBtn":"File_closeBtn__3uO2V","fileSelected":"File_fileSelected__3R9B5","disabled":"File_disabled__zH958"};